/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "react-tooltip";

import { GOOGLE_ADS_DOWNLOAD_AUDIO_ID } from "@/constants/googleAds";
import { DOWNLOAD_AUDIO_TYPES } from "@/constants/posthog/downloadAudio";
import { trackAudioDownload } from "@/data/posthog/trackAudioDownload";
import { IsolationConstructedNoDates } from "@/types/types";
import { fireGoogleAdsConversion } from "@/utils/gtag/fireGoogleAdsConversion";

export function DownloadIsolation({
  isolation,
}: {
  isolation: IsolationConstructedNoDates;
}) {
  const trackDownload = () => {
    trackAudioDownload({
      audioType: DOWNLOAD_AUDIO_TYPES.ISOLATION,
      entityId: isolation.id,
    });
    fireGoogleAdsConversion({
      conversionLabel: GOOGLE_ADS_DOWNLOAD_AUDIO_ID,
      additionalData: null,
    });
  };

  return (
    <a
      data-testid={`isolation-id-output-${isolation.id}`}
      href={
        isolation.outputSound?.presignedUrlDownload ||
        isolation.outputSoundMp3!.presignedUrlDownload
      }
      download={
        isolation.outputSound?.filename || isolation.outputSoundMp3!.filename
      }
      onClick={trackDownload}
    >
      <ArrowDownTrayIcon
        data-tooltip-id={`download-isolation-tooltip-${isolation.id}`}
        data-tooltip-content="Download"
        data-tooltip-place="top"
        className="h-6 w-6 stroke-gray-900"
      />
      <Tooltip id={`download-isolation-tooltip-${isolation.id}`} />
    </a>
  );
}
